var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958984H513V342.959H0V0.958984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958984H513V114.959H0V0.958984Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.959H513V342.959H0V228.959Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3 114.159V70.1588L326.8 55.7588L344.5 70.1588V114.159H309.3ZM203.7 114.159V70.1588L186.4 55.7588L168.5 70.1588V114.159H203.7ZM238.9 114.159V70.1588L256.5 55.7588L274.1 70.1588V114.159H238.9Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3 114.159H274.1V70.1588L291.6 55.7588L309.3 70.1588V114.159ZM238.9 114.159H203.7V70.1588L221.2 55.7588L238.9 70.1588V114.159Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 114.159V216.059C168.5 240.359 182.9 262.259 203.9 275.459C225.2 288.859 246 290.159 256.5 290.159C267 290.159 287.9 288.459 309.1 275.359C330.1 262.359 344.5 240.259 344.5 216.059V114.159H168.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 113.659H345V216.059C345 240.462 330.483 262.71 309.363 275.784C288.055 288.951 267.05 290.659 256.5 290.659C245.957 290.659 225.048 289.354 203.634 275.883C182.518 262.61 168 240.564 168 216.059V113.659ZM169 114.659V216.059C169 240.155 183.282 261.908 204.166 275.036C225.352 288.364 246.043 289.659 256.5 289.659C266.95 289.659 287.746 287.967 308.837 274.934C329.717 262.008 344 240.056 344 216.059V114.659H169Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 114.159H203.7V149.359H168.5V114.159ZM238.9 114.159H274.1V149.359H238.9V114.159ZM309.3 114.159H344.5V149.359H309.3V114.159ZM203.7 149.359H238.9V184.559H203.7V149.359ZM274.1 149.359H309.3V184.559H274.1V149.359ZM168.5 184.559H203.7V219.759H168.5V184.559ZM203.7 219.759H238.9V254.959H203.7V219.759ZM238.9 184.559H274.1V219.759H238.9V184.559ZM309.3 184.559H344.5V219.759H309.3V184.559ZM274.1 219.759H309.3V254.959H274.1V219.759ZM309.3 275.259C317.9 269.859 325.5 262.959 331.3 254.959H309.3V275.259ZM181.7 254.959C187.5 262.959 195 269.859 203.7 275.359V254.959H181.7ZM238.9 254.959V288.659C246.1 289.859 252.2 290.159 256.5 290.159C260.8 290.159 266.9 289.859 274.1 288.559V254.959H238.9Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.cb292df4fa96e7fc6ed5f2454a9aafbc.svg";
export { ForwardRef as ReactComponent };